import { Stepper } from '@avanta/shared/components/Stepper';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import Logo from '@/assets/itae-agendar.svg';
import { SupportButton } from 'components/SupportButton';
import { ROUTES } from 'constants/routes';
import { AppointmentsReservePayload } from 'pages/AppointmentsReserve/constants';
import { type StepDefinition } from 'pages/AppointmentsReserve/hooks/useStepNavigation';
import { type AppointmentsReserveFormData } from 'pages/AppointmentsReserve/types';

interface TopNavProps {
  steps: StepDefinition[];
  currentStep: number;
}

export const TopNav = ({ steps, currentStep }: TopNavProps): React.ReactElement => {
  const { t } = useTranslation(LOCIZE_NS.APPOINTMENTS);
  const { control } = useFormContext<AppointmentsReserveFormData>();
  const flow = useWatch({ control, name: AppointmentsReservePayload.flow });

  return (
    <div className="relative mb-12">
      <header className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-18">
        <Link to={ROUTES.HOME} className="flex items-center">
          <img src={Logo} alt="itae" className="h-12 w-auto object-contain" />
        </Link>
        <SupportButton onInNewTab />
      </header>
      <div className="container mx-auto flex max-w-3xl flex-col items-center gap-4.5 px-4">
        <h1 className="mt-2 text-center text-2xl font-medium leading-7 text-denim-800">
          {t(`AppointmentsReserve.${flow}.title`)}
        </h1>
        <Stepper
          steps={steps}
          currentStep={currentStep}
          i18nKey="AppointmentsReserve.Steps"
          i18nNs={LOCIZE_NS.APPOINTMENTS}
        />
      </div>
    </div>
  );
};
